var SupportV1INTLViewManagerHelper, SupportV1USViewManagerHelper, SupportV2USViewManagerHelper, SupportVerticalHelpWizardViewManagerHelper, SupportViewManagerFactoryView;

SupportV1USViewManagerHelper = require('./US/v1');

SupportV1INTLViewManagerHelper = require('./INTL/v1');

SupportV2USViewManagerHelper = require('./US/v2');

SupportVerticalHelpWizardViewManagerHelper = require('./vertical_view_manager');

SupportViewManagerFactoryView = {
  getViewManager: function() {
    var ref;
    if (window.isUS()) {
      if (Groupon.Support.FeatureFlagModel.isRedesignOrdersUSEnabled()) {
        return new SupportV2USViewManagerHelper;
      } else {
        return new SupportV1USViewManagerHelper;
      }
    } else {
      if (window.evaluate((ref = window.experiments) != null ? ref.showVerticalPageFlow : void 0)) {
        return new SupportVerticalHelpWizardViewManagerHelper;
      } else {
        return new SupportV1INTLViewManagerHelper;
      }
    }
  }
};

module.exports = SupportViewManagerFactoryView;

//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiL3Zhci9ncm91cG9uL2hvbWUvcm11cnVnYW4vbmFwaXN0cmFuby9idWlsZC8xNTAxNzgyMDE2MzA2LTU5NDM1L3Byb2R1Y3Rpb24tMjAxNy4wOC4wM18xNy4zNi9zdXBwb3J0X2FwcC9tb2R1bGVzL3N1cHBvcnQvZnJvbnRlbmQvdmlld19tYW5hZ2VyL3ZpZXdfbWFuYWdlcl9mYWN0b3J5LmNvZmZlZSIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi92YXIvZ3JvdXBvbi9ob21lL3JtdXJ1Z2FuL25hcGlzdHJhbm8vYnVpbGQvMTUwMTc4MjAxNjMwNi01OTQzNS9wcm9kdWN0aW9uLTIwMTcuMDguMDNfMTcuMzYvc3VwcG9ydF9hcHAvbW9kdWxlcy9zdXBwb3J0L2Zyb250ZW5kL3ZpZXdfbWFuYWdlci92aWV3X21hbmFnZXJfZmFjdG9yeS5jb2ZmZWUiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUEsSUFBQTs7QUFBQSw0QkFBQSxHQUErQixPQUFBLENBQVEsU0FBUjs7QUFDL0IsOEJBQUEsR0FBaUMsT0FBQSxDQUFRLFdBQVI7O0FBQ2pDLDRCQUFBLEdBQStCLE9BQUEsQ0FBUSxTQUFSOztBQUMvQiwwQ0FBQSxHQUE2QyxPQUFBLENBQVEseUJBQVI7O0FBRTdDLDZCQUFBLEdBRUU7RUFBQSxjQUFBLEVBQWdCLFNBQUE7QUFDZCxRQUFBO0lBQUEsSUFBRyxNQUFNLENBQUMsSUFBUCxDQUFBLENBQUg7TUFDRSxJQUFHLE9BQU8sQ0FBQyxPQUFPLENBQUMsZ0JBQWdCLENBQUMseUJBQWpDLENBQUEsQ0FBSDtlQUNFLElBQUksNkJBRE47T0FBQSxNQUFBO2VBR0UsSUFBSSw2QkFITjtPQURGO0tBQUEsTUFBQTtNQU1FLElBQUcsTUFBTSxDQUFDLFFBQVAseUNBQWtDLENBQUUsNkJBQXBDLENBQUg7ZUFDRSxJQUFJLDJDQUROO09BQUEsTUFBQTtlQUdFLElBQUksK0JBSE47T0FORjs7RUFEYyxDQUFoQjs7O0FBWUYsTUFBTSxDQUFDLE9BQVAsR0FBaUIifQ==
